// Helpers de alcance por papel e capabilities da sessão. A entrada das rotas
// é definida pelo contrato do backend em route-policy.ts.
import type { Session } from "@/contracts";
import { isFeatureVisible } from "@/lib/feature-visibility";

export function isManager(role: string | null | undefined): boolean {
  return role === "mentor" || role === "admin";
}

// A sessão concede esta capability? O back gateia de verdade; isto evita renderizar
// afordância (botão/ação) que o usuário não pode executar (anti-botão-falso). Mesma
// fonte que o sidebar usa (session.capabilities). `viewAs` não afrouxa: a capability
// já reflete o contexto efetivo da sessão.
export function hasCapability(session: Session | null | undefined, slug: string): boolean {
  return session?.capabilities.some((c) => c.slug === slug) ?? false;
}

// A funcionalidade (feature-flag) está ligada para o sujeito? Default-on: espelha
// o assertFeatureEnabled do back — ligada a menos que o flag exista e esteja OFF,
// respeitando também as funcionalidades temporariamente ocultas no produto.
// Usada no guard de rota para não abrir por deep-link um módulo desligado.
export function featureEnabled(session: Session | null | undefined, flag: string): boolean {
  return isFeatureVisible(flag) && session?.features?.[flag] !== false;
}
